import { useContext, createContext } from 'react';

export const FEATURE_DEFINITIONS = [
  { key: 'dashboard', label: 'Dashboard', category: 'Core', minRole: 'rig' },
  { key: 'drilling_diamond', label: 'Diamond drilling', category: 'Drilling', minRole: 'rig' },
  { key: 'drilling_conventional', label: 'Conventional drilling', category: 'Drilling', minRole: 'rig' },
  { key: 'drilling_chipping', label: 'Chipping', category: 'Drilling', minRole: 'rig' },
  { key: 'drilling_air_core', label: 'Air Core', category: 'Drilling', minRole: 'rig' },
  { key: 'drilling_rc', label: 'RC', category: 'Drilling', minRole: 'rig' },
  { key: 'daily_log', label: 'Daily Log', category: 'Notebook', minRole: 'rig' },
  { key: 'daily_report', label: 'Daily Report', category: 'Notebook', minRole: 'rig' },
  { key: 'documents', label: 'Documents', category: 'Notebook', minRole: 'rig' },
  { key: 'handover', label: 'Handover', category: 'Notebook', minRole: 'rig' },
  { key: 'tools', label: 'Tools', category: 'Utilities', minRole: 'rig' },
  { key: 'calculators', label: 'Calculators', category: 'Utilities', minRole: 'rig' },
  { key: 'viscosity_check', label: 'Viscosity Check', category: 'Utilities', minRole: 'rig' },
  { key: 'flow_rate', label: 'Flow Rate', category: 'Utilities', minRole: 'rig' },
  { key: 'stocktake', label: 'Stocktake', category: 'Utilities', minRole: 'rig' },
  { key: 'order', label: 'Order', category: 'Utilities', minRole: 'rig' },
  { key: 'reporting', label: 'Reporting', category: 'Management', minRole: 'supervisor' },
  { key: 'settings', label: 'Settings', category: 'Management', minRole: 'rig' },
  { key: 'force_sync', label: 'Force Sync', category: 'Shift & Sync', minRole: 'rig' },
  { key: 'end_shift', label: 'End Shift', category: 'Shift & Sync', minRole: 'rig' },
  { key: 'user_management', label: 'User Management', category: 'Administration', minRole: 'admin' },
  { key: 'audit_logs', label: 'Audit Logs', category: 'Administration', minRole: 'admin' },
  { key: 'admin_requests', label: 'Admin Requests', category: 'Administration', minRole: 'admin' },
  { key: 'document_builder', label: 'Document Builder', category: 'Administration', minRole: 'admin' },
  { key: 'feature_permissions', label: 'Feature Permissions', category: 'Administration', minRole: 'admin' },
  { key: 'support', label: 'Support', category: 'Core', minRole: 'rig' },
];

export const FEATURE_KEYS = Object.fromEntries(FEATURE_DEFINITIONS.map((feature) => [feature.key, feature.key]));

export const ROLE_KEYS = ['rig', 'supervisor', 'admin', 'owner'];

export function defaultFeaturePermissions() {
  const matrix = {};
  for (const feature of FEATURE_DEFINITIONS) {
    matrix[feature.key] = Object.fromEntries(ROLE_KEYS.map((role) => [role, true]));
  }
  return matrix;
}

const FeaturePermissionContext = createContext(null);
export const FeaturePermissionProvider = FeaturePermissionContext.Provider;

export function useFeaturePermissions() {
  const context = useContext(FeaturePermissionContext);
  if (!context) throw new Error('useFeaturePermissions must be used within FeaturePermissionProvider');
  return context;
}
